'use strict'

import * as types from '@/store/types.js'

const state = {
  timeout: 0,
  currentTime: 0,
  lastActionTime: 0
}

const mutations = {
  [types.TIMER.timeout.update]: (store, timeout) => {
    store.timeout = timeout
  },
  [types.TIMER.currentTime.update]: (store) => {
    store.currentTime += 1
  },
  [types.TIMER.lastActionTime.update]: (store) => {
    store.lastActionTime = store.currentTime
  }
}

const actions = {
  [types.TIMER.timeout.update] (context, { timeout }) {
    context.commit(types.TIMER.timeout.update, timeout)
  },
  [types.TIMER.currentTime.update] (context) {
    context.commit(types.TIMER.currentTime.update)
  },
  [types.TIMER.lastActionTime.update] (context) {
    context.commit(types.TIMER.lastActionTime.update)
  }
}

export default {
  state,
  mutations,
  actions
}
